<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-dollar-sign"
      texto-titulo="Listado de ventas"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList
          url="/movimientos"
          :fields="fields"
          :rowClick="ver"
          :toPesos="toPesos"
          :toDate="toDate"
          ref="datatable"
        ></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import axios from 'axios';
import DataList from "@/components/layouts/DataList";
import Swal from "sweetalert2";

export default {
  name: "ListarVentas",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      fields: [
        {
          name: "denominacion",
          label: "",
          type: "title",
          class: "text-alternate",
          append: " - "
        },
        {
          name: "total",
          label: "",
          type: "title",
          class: "text-success",
          prepend: "$"
        },
        {
          name: "cliente.nombre",
          label: "Cliente",
          type: "field",
          class: "text-info"
        },
        {
          name: "forma_pago",
          label: "Forma de pago",
          type: "field",
          class: ""
        },
        {
          name: "created_at",
          label: "Fecha",
          type: "field",
          class: ""
        },
        {
          name: "user.nombre",
          label: "Vendedor",
          type: "field",
          class: ""
        },
        {
          name: "estado_reparto",
          label: "Reparto",
          type: "field",
          class: ""
        },
        {
          name: "fecha_reparto",
          label: "Fecha de reparto",
          type: "field",
          class: ""
        },
        {
          name: "repartido_por",
          label: "Repartidor",
          type: "field",
          class: ""
        }
      ],
      toPesos: ["total"],
      toDate: ["created_at", 'fecha_reparto'],
      loading: false
    };
  },
  mounted() {
    console.log(this.$store.state.auth.user)
  },
  methods: {
    ver(movimiento) {
      if (movimiento.tipo === 'Venta') {
        if (movimiento.denominacion.charAt(0) === 'R' && this.$store.state.auth.user.tipo === 'Administrador') {
          Swal.fire({
            title: '¿Que deseas hacer con el remito ' + movimiento.denominacion + '?',
            showDenyButton: true,
            showCancelButton: true,
            cancelButtonColor: '#6e7881',
            denyButtonColor: '#3ac47d',
            confirmButtonText: 'Facturar',
            denyButtonText: `Imprimir`,
            cancelButtonText: 'Cancelar',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.facturarRemito(movimiento)
            } else if (result.isDenied) {
              window.open(
                `${axios.defaults.baseURL}/imprimir/comprobante/${movimiento.id}`
              );
            }
          })
        } else {
          window.open(
            `${axios.defaults.baseURL}/imprimir/comprobante/${movimiento.id}`
          );
        }
      }
    },
    facturarRemito(movimiento) {
      this.loading = true;
      axios.get('movimiento/facturar-remito/' + movimiento.id).then((response) => {
        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: `${response.data.movimiento.denominacion} se guardó con éxito.`,
        });
        this.$refs['datatable'].update()
      })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido guardar correctamente`,
          });

        })
        .finally(() => this.loading = false)
    }
  }
};
</script>
